import { useState, useEffect } from 'react';

export const useCurrentTime = (): number => {
  const [time, setTime] = useState<number>(Date.now());

  useEffect(() => {
    const timer = setInterval(() => setTime(Date.now()), 1000);

    return () => clearInterval(timer);
  }, []);

  return time;
};
